import { wrapper } from './proto-generated';
export var WixApi = wrapper.wix.api;
export var ApiTypes = wrapper.wix.social.groups.api;
export var FeedApiTypes = wrapper.wix.feed;
export var CommentsApiTypes = wrapper.wix.comments;
export var ReactionsApiTypes = wrapper.wix.reactions;
export var SocialApiTypes = wrapper.wix.social;
export var CommonTypes = wrapper.wix.common;
export var ApiHostName;
(function (ApiHostName) {
    ApiHostName["WIX"] = "www.wix.com";
    ApiHostName["MANAGE_WIX"] = "manage.wix.com";
    ApiHostName["GROUPS"] = "groups.wixapps.net";
    ApiHostName["EDITOR"] = "editor.wix.com";
    ApiHostName["EDITORX"] = "editorx.com";
    ApiHostName["EDITORWIXAPPS"] = "editor.wixapps.net";
    ApiHostName["DEV_WIX_CODE"] = "dev.wix-code.com";
})(ApiHostName || (ApiHostName = {}));
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    RequestStatus["PENDING"] = "PENDING";
    RequestStatus["APPROVED"] = "APPROVED";
    RequestStatus["REJECTED"] = "REJECTED";
})(RequestStatus || (RequestStatus = {}));
//# sourceMappingURL=types.js.map